module.exports = __webpack_public_path__ + "static/media/screen-orientation.737d2771.svg";